import React from 'react';
import { Breadcrumb } from 'antd';
import { StyledWebhooksContainer } from '../styled';
import WebhooksList from './WebhooksList';
import WebhooksHeader from '../WebhooksHeader';
import useFetchWebhooksList from '../hooks/useWebhooksList';
import { getModuleLabel } from '../utils';
import AdminOnly from '@src/components/common/AdminOnly';

const Webhooks = () => {
  const { context, module } = window.conviva;
  const { data, error, isLoading }: any = useFetchWebhooksList({ context });

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <StyledWebhooksContainer>
      <Breadcrumb>
        <Breadcrumb.Item>
          {`${getModuleLabel(module)} Webhooks `}
          <AdminOnly />
        </Breadcrumb.Item>
      </Breadcrumb>
      <WebhooksHeader webhookList={data} />
      <WebhooksList webhookList={data} />
    </StyledWebhooksContainer>
  );
};

export default Webhooks;
